import { Remarkable } from 'remarkable';

export default {
    created() {
        this.markdown = new Remarkable({
            typographer : true,
            quotes      : '“”‘’'
        });
    }
};
